import api from "Utilities/api";
import { useState } from "react";

export interface ApiResponse<T = any> {
  data: T | undefined;
  status: number | undefined;
  error: Error | null;
  isLoading: boolean;
  postData: (
    postData: T
  ) => Promise<T> | Promise<void> | Promise<unknown> | Promise<Error>;
}

const usePost = <T = any,>(url: string, timeout?: number): ApiResponse<T> => {
  const [data, setData] = useState<T>();
  const [status, setStatus] = useState<number | undefined>(undefined);
  const [error, setError] = useState<Error | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Post
  const postData = async (postData: T) => {
    setIsLoading(true);

    // I need it to reset the values correctly.
    setData(undefined);
    setError(null);

    try {
      const response = await api.post(url, postData, {
        timeout: timeout ?? 15000,
      });
      setData(response.data);
      setStatus(response.status);
    } catch (error: unknown) {
      if (error instanceof Error) {
        setError(error);
      } else {
        setError(new Error("An unknown error occurred."));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    status,
    error,
    isLoading,
    postData,
  };
};

export default usePost;
